module.exports = __webpack_public_path__ + "img/error.01591cab.svg";